import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    notifications: null,
	duplicate: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.PUBLIC_FORMS_RESET:
            return {
                ...state,
				notifications: null,
				duplicate: null
            }

        case types.PUBLIC_FORM_CREATE:
            return {
                ...state,
                isLoading: true
            }

        case types.PUBLIC_FORM_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.PUBLIC_FORM_CREATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.PUBLIC_FORM_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.PUBLIC_FORM_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.PUBLIC_FORM_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.PUBLIC_FORM_UPDATE:
            return {
                ...state,
                isLoading: true
            }

        case types.PUBLIC_FORM_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.PUBLIC_FORM_UPDATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.NOTIFICATIONS_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.NOTIFICATIONS_FETCH_SUCCESS:
            return {
                ...state,
                notifications: action.notifications,
                isLoading: false
            }

        case types.NOTIFICATIONS_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

		case types.PUBLIC_FORM_CLONE:
            return {
                ...state,
                isLoading: true
            }

        case types.PUBLIC_FORM_CLONE_SUCCESS:
            return {
                ...state,
                isLoading: false,
				duplicate: action.duplicate
            }

        case types.PUBLIC_FORM_CLONE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        default:
            return state
    }
}
